import Dexie from 'dexie'

let Db = new Dexie("SePortal")

Db.version(1).stores({
	configs: 'key,value'
})

export default Db



// WEBPACK FOOTER //
// ./src/dixie.js